import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const updateWaitType = async (data) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found");
  const user = JSON.parse(userDetails);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateBefore&companyid=${user.companyid}&teststepid=${data.teststepid}&before=${data.before}&testcaseid=${data.tcid}`,
    {
      teststepid: data.teststepid,
      tcid: data.tcid,
      before: data.before
    }
  );

  return response.data;
};

const useUpdateWaitTypeMutation = (options = {}) => {
  return useMutation({
    mutationFn: updateWaitType,
    ...options,
  });
};

export default useUpdateWaitTypeMutation; 